export default __webpack_public_path__ + "d12b3f66b5ccc4c51db19c23f22ba892.png";